import { Record as record } from 'immutable';
import _ from 'lodash';

import { getDefaults, getResolvers } from '../../helpers/Records';
import { construct, fields, resolve } from '../../helpers/LinkMapper';
import Station from '../Station';
import Route from '../Route';
import TicketType from '../TicketType';
import ValidityPeriod from '../ValidityPeriod';

const fieldSchema = {
    "id": [ fields.string ],
    "customerUNID": [ fields.string ],
    "origin": [ resolve.as(Station) ],
    "destination": [ resolve.as(Station) ],
    "route": [ resolve.as(Route) ],
    "ticketType": [ resolve.as(TicketType) ],
    "saleTicketNumber": [ fields.number ],
    "price": [ fields.number ],
    "validFrom": [ fields.datetime ],
    "validTo": [ fields.datetime ],
    "validityPeriod": [ resolve.with(ValidityPeriod.fromString) ],
    "adults": [ fields.number ],
    "children": [ fields.number ],
    "ticketClass": [ fields.string ],
    "methodOfPayment": [ fields.string ]
};

class PaperSeasonTicket extends record(getDefaults(fieldSchema)) {

    static fromJSON(json = {}) {
        json = Object.assign({ id: _.uniqueId('paperseasonticket') }, json);
        return construct(PaperSeasonTicket, json, getResolvers(fieldSchema));
    }

    isStandard () {
        return this.ticketClass === 'Standard';
    }

    isFirstClass () {
        return this.ticketClass === "First";
    }
}

export default PaperSeasonTicket;



// WEBPACK FOOTER //
// ./src/records/customer/PaperSeasonTicket.js